import { get } from "lodash";
import * as React from "react";
import NumberFormat, { NumberFormatProps } from "react-number-format";
import { Input, InputProps } from ".";

type Props = InputProps & NumberFormatProps;

const toDisplayValue = (value: unknown): string | number => {
  if (typeof value === "number") return value;
  if (typeof value === "string") return value;
  return "";
};

export default function DollarInputV2(props: Props) {
  const {
    value: valueProp,
    formik,
    name,
    label,
    error,
    horizontal,
    search,
    formatOn,
    formatter,
    isLoading,
    size,
    $size,
    onValueChange,
    ...numberFormatProps
  } = props;

  const formikValue =
    name && formik ? get(formik.values, name) : undefined;

  const displayValue: string | number =
    valueProp !== undefined && valueProp !== null
      ? toDisplayValue(valueProp)
      : toDisplayValue(formikValue);

  return (
    <NumberFormat
      // @ts-ignore customInput typing conflicts with styled Input wrapper
      customInput={Input}
      prefix="$"
      thousandSeparator={true}
      decimalScale={2}
      fixedDecimalScale={true}
      isNumericString
      onValueChange={(values, sourceInfo) => {
        if (name && formik) {
          const next =
            values.floatValue !== undefined && values.floatValue !== null
              ? values.floatValue
              : null;
          if (get(formik.values, name) !== next) {
            formik.setFieldValue(name, next);
          }
        }
        onValueChange?.(values, sourceInfo);
      }}
      {...numberFormatProps}
      value={displayValue}
    />
  );
}
